import { Component, Input } from '@angular/core';
import { ANPRInspectionConfigAuth, InspectionConfigBaseAuth } from '../../../models/InspectionConfiguration';
import { CommonModule } from '@angular/common';
import { ControlContainer, FormGroup, FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-anpr-auth-configs',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  viewProviders: [
    { provide: ControlContainer, useExisting: NgForm }
  ],
  templateUrl: './anpr-auth-configs.component.html',
  styleUrl: './anpr-auth-configs.component.scss'
})
export class ANPRAuthConfigsComponent {
  showPassword = false;
  showApiKey = false;

  @Input()
  authConfig: ANPRInspectionConfigAuth = {};
}
